module.exports = __webpack_public_path__ + "img/logo.f8159a03.png";